import React from "react";
import { Tooltip } from "../ui";

export const UserSupervisorToolTip: React.FC = () => {
  const message = <p>Supervisors are copied on all emails sent.</p>;

  return <Tooltip message={message} />;
};

export const UserEmailSettingsToolTip: React.FC = () => {
  const message = <p>Email settings do not apply to vendors with portal access; emails are automatically generated.</p>;

  return <Tooltip message={message} iconSize={18} />;
};
